import { render, staticRenderFns } from "./searchHistory.vue?vue&type=template&id=63e11b2a&scoped=true&"
import script from "./searchHistory.vue?vue&type=script&lang=ts&"
export * from "./searchHistory.vue?vue&type=script&lang=ts&"
import style0 from "./searchHistory.vue?vue&type=style&index=0&id=63e11b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e11b2a",
  null
  
)

export default component.exports